import React from "react";

// locales
import i18n from '../../i18n';
// the hoc
import { withTranslation } from 'react-i18next';

class ResearchLanguage extends React.Component {

	render() {
		var arr = i18n.t('test.array', { returnObjects: true });

		return (
			<div className="container-language-test">
				<p>
					<a className="btn btn-primary" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
						toggle language test</a>
				</p>
				<div className="collapse" id="collapseExample">
					<div className="card card-body">

						<h3>{i18n.t('welcome.title', { framework: 'React' })}</h3>
						<h3>{i18n.t('Welcome to React')}</h3>

						<pre>{i18n.t('test.array', { returnObjects: true })}</pre>
						<pre>{i18n.t('test.array', {
							returnObjects: true,
							joinArrays: false,
						})}</pre>

						{/* {console.log(arr)} */}

						<ul>
							{
								arr.map((value, key) =>
									<li className="nav-item" key={key}>
										<p>{value}</p>
									</li>
								)
							}
						</ul>

						<pre>{i18n.t('test.array[0]')}</pre>

						<pre>{i18n.t('arrayJoin', { joinArrays: '+' })}</pre>

						<pre>{i18n.t('arrayJoinWithInterpolation', { myVar: 'interpolate', joinArrays: ' ' })}</pre>

						<pre>{i18n.t(`arrayOfObjects.0.name`)}</pre>

					</div>
				</div>
			</div>
		);
	}
}

export default withTranslation()(ResearchLanguage);